// ORS has no provider for the URL, so a retry cannot change the answer.
const UNSUPPORTED_ERROR_TYPES = new Set(['UnsupportedError', 'ResolveUnsupportedError']);

const unresolvableUrls = new Set<string>();

export const isUrlUnresolvable = (url: string): boolean => unresolvableUrls.has(url);

export const isUnsupportedUrlError = (error: unknown): boolean => {
	const type = (error as { type?: unknown } | null)?.type;
	return typeof type === 'string' && UNSUPPORTED_ERROR_TYPES.has(type);
};

export const markUrlUnresolvable = (url: string): void => {
	unresolvableUrls.add(url);
};

// Exported for tests: the Set outlives a single render, so suites must clear it between cases.
export const resetUnresolvableUrls = (): void => {
	unresolvableUrls.clear();
};
